import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/bundles-in-depop';

export default function Example() {
  return (
    <>
      <Head>
        <title>Depop Bundles: Multiple sales for you, lower shipping for buyers</title>
        <meta
          name='description'
          content="Here's how to sell bundles on Depop and make it work for you and your shop."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/bundles-in-depop' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/bundles-in-depop' />
        <meta property='og:title' content='Depop Bundles: Multiple sales for you, lower shipping for buyers' />
        <meta
          property='og:description'
          content="Here's how to sell bundles on Depop and make it work for you and your shop."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Depop' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
